module.exports = __webpack_public_path__ + "static/Excitedman-dadd8c01d823c3fc597d1f5ae4db0aee.png";